/*
  Launch pages: shared cart helper.
  Adds one or more variants in a single /cart/add.js call, then asks the theme
  mini cart to refresh and open (theme:cart:refresh is handled by mini_cart.js,
  which re-renders the drawer, fires theme:cart:added and opens the drawer).
  Any element with [data-launch-add] and data-variant-ids="id,id,id" is wired.
*/
(function () {
  if (window.LaunchCart) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var locale = document.documentElement.lang || 'en';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (whole ? cents / 100 : (cents / 100).toFixed(2));
    }
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg = (data && (data.description || data.message)) || 'Could not add to cart.';
          throw new Error(msg);
        }
        return data;
      });
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      document.dispatchEvent(new CustomEvent('launch:cart:changed', { detail: data }));
      return data;
    });
  }

  function setStatus(btn, text, isError) {
    var id = btn.getAttribute('aria-describedby');
    var el = id ? document.getElementById(id) : null;
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-error', !!isError);
  }

  function onClick(e) {
    var btn = e.target.closest('[data-launch-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var ids = (btn.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
    var label = btn.querySelector('[data-launch-add-label]');
    var original = label ? label.textContent : '';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = btn.getAttribute('data-adding-text') || 'Adding';
    setStatus(btn, '');
    addItems(items).then(function () {
      setStatus(btn, btn.getAttribute('data-added-text') || 'Added to cart');
    }).catch(function (err) {
      setStatus(btn, err.message, true);
    }).then(function () {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (label) label.textContent = original;
    });
  }

  document.addEventListener('click', onClick);

  window.LaunchCart = { addItems: addItems, getCart: getCart, formatMoney: formatMoney };
})();
